import type { HTMLAttributes, PropsWithChildren } from 'react'
import { cn } from '@/shared/lib/cn'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padded?: boolean
}

export const Card = ({
  children,
  className,
  padded = true,
  ...props
}: PropsWithChildren<CardProps>) => (
  <div
    className={cn(
      'rounded-[var(--radius)] border border-[var(--color-border)] bg-[var(--color-bg-surface)] shadow-[0_4px_12px_rgba(31,43,40,0.04)] transition-[transform,box-shadow,border-color] duration-200 ease-out motion-reduce:transition-none',
      padded && 'p-4',
      className,
    )}
    {...props}
  >
    {children}
  </div>
)

